import React, { useState } from 'react'
import { Card, Col, Row, Form, Button, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify';
import cp_bg from '../../images/cyberpass_bg.jpg'
import { CNPJ } from 'helpers/Input'
import masterAgentService from '../../services/master-agent-request';
import swal from '../../helpers/swal';
import Swal from 'sweetalert2';
import { history } from 'store';
import { validateDocument } from '../../helpers/document'
import { useCompany } from 'models';

const CyberpassForm = () => {
  const { company: currentCompany } = useCompany()

  const [data, setData] = useState({
    partner_level: "Parceiro Scansource",
    licensing: []
  });
  const [isLoading, setIsLoading] = useState(false)

  const fields = [
    { label: 'E-mail', prop: 'email', type: 'email', required: true },
    { label: 'Razão Social do Canal/Parceiro Cyberpass', prop: 'channel_name', type: 'input', required: true },
    { label: 'Nível de Parceria do Canal/Parceiro Cyberpass', prop: 'partner_level', type: 'radio', required: true },
    { label: 'Razão Social do Cliente Final', prop: 'client_company_name', type: 'input', required: true },
    { label: 'CNPJ do Cliente Final (00.000.000/0000-00)', prop: 'cnpj', type: 'cnpj', required: true },
    {
      label: 'Licenciamento Cyberpass a ser oferecido',
      prop: 'licensing',
      type: 'checkbox',
      options: ['CP - Guest', 'CP - Corp', 'CP - Safe', 'CP - Insight'],
      required: true,
    },
    { label: 'Quantidade de Licenças Estimadas', prop: 'licensing_amount', type: 'input', required: true },
    {
      label: 'Previsão do Fechamento do Negócio',
      prop: 'closing_forecast',
      type: 'select',
      options: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ],
      required: true
    },
    { label: 'Descreva brevemente o Escopo do Projeto', prop: 'scope_project', type: 'input', required: false }
  ]

  const handleGetData = prop => {
    return data[prop]
  }

  const handleChangeData = (value, prop) => {
    let _aux = data
    _aux[prop] = value
    setData(_aux)
  }

  const renderField = (field) => {
    if (field.type == "input" || field.type == "email") {
      return (
        <Form.Control
          value={handleGetData(field.prop)}
          type={field.type}
          onChange={({ target }) => handleChangeData(target.value, field.prop)}
        />
      )
    } else if (field.type == "radio") {
      return (
        <Form.Check
          checked
          type="radio"
          value="Parceiro Scansource"
          label="Parceiro Scansource"
        />
      )
    } else if (field.type == "cnpj") {
      return (
        <CNPJ onChange={({ target }) => handleChangeData(target.value, field.prop)} />
      )
    } else if (field.type == "checkbox") {
      return (<>
        {field.options.map((option, key) => (
          <Form.Check
            key={key}
            type="checkbox"
            value={option}
            label={option}
            onChange={e => {
              let _aux = handleGetData(field.prop)
              if (e.target.checked && _aux.indexOf(e.target.value) == -1)
                _aux.push(e.target.value)
              else if (!e.target.checked && _aux.indexOf(e.target.value) > -1)
                _aux.splice(_aux.indexOf(e.target.value), 1)

              handleChangeData(_aux, field.prop)
            }}
          />
        ))}
      </>)
    } else {
      return (<>
        <Form.Control
          as="select"
          onChange={({ target }) => handleChangeData(target.value, field.prop)}
        >
          <option disabled selected>Escolher</option>
          {field.options.map((option, key) => (
            <option key={key}>{option + '/' + new Date().getFullYear()}</option>
          ))}
        </Form.Control>
      </>)
    }
  }

  const validateFields = () => {
    const showError = message => {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    let hasErrors = 0
    fields.map(field => {
      if ((!data[field.prop] || data[field.prop].length == 0) && field.required) {
        showError(field.label)
        hasErrors++;
      }

      if (field.prop == "cnpj") {
        const isValid = validateDocument(field.prop, data[field.prop])
        if (!isValid) {
          showError('CNPJ não é válido')
          hasErrors++
        }
      }
    })

    return hasErrors == 0
  }

  return (<>
    <Card className="mt-3">
      {/* <Card.Img src={cp_bg} /> */}
      <Card.Body style={{ background: "#004B8B", color: "#FFFFFF" }}>
        <Row>
          <Col md="12" className="mb-3">
            <Card.Title>
              <span style={{ color: "#FFFFFF" }} className="h2">
                REGISTRO DE OPORTUNIDADE GESTÃO DE ACESSO A REDE WIFI – CyberPass
              </span>
            </Card.Title>
            <Card.Text>
              Preencha o formulário abaixo para registrar um lead com a <strong><u>CyberPass</u></strong>, todas as informações são obrigatórias.
            </Card.Text>
            <Card.Text>
              <span className="font-weight-bold">AVISO IMPORTANTE</span>: Todas as informações apresentadas aqui são estritamente confidenciais.
              Manteremos contato somente com o responsável descrito neste formulário para alinhamento da
              oportunidade, e assim, prosseguiremos o projeto com o Provedor de Serviços, que atuará em
              conjunto com o parceiro e a ScanSource Master Agent.
            </Card.Text>
            <Card.Text>
              <span style={{ color: "#ffee00" }}>
                O RO tem validade de 90 dias, durante esse período é necessário que o parceiro nos comunique de interações no cliente final, 
                a fim de garantir o Registro de Oportunidade para sua empresa
              </span>
            </Card.Text>
            <Card.Text>
              Daremos um retorno da análise em 24 horas, para confirmação do registro.
            </Card.Text>
          </Col>
        </Row>
      </Card.Body>
      <Card.Body>
        <Row>
          <Col md="12">
            <small><span className="text-danger">*</span> Obrigatória</small><br /><br />
          </Col>
          <Col md="12">
            <Form>
              {fields.map((field, key) => {
                return (
                  <Form.Group key={key}>
                    <Form.Label>{field.label} {field.required ? <span className="text-danger">*</span> : null}</Form.Label>
                    {renderField(field)}
                  </Form.Group>
                )
              })}
            </Form>
          </Col>
          <Col md="12">
            <Button
              disabled={isLoading}
              className="button-next"
              onClick={e => {
                e.preventDefault()
                const valid = validateFields()
                if (valid) {
                  setIsLoading(true)
                  let formData = new FormData()
                  formData.append('provider_id', 4)
                  formData.append('company_id', currentCompany.id);
                  formData.append('form_type', 'cyberpass');
                  formData.append('form_data', JSON.stringify(data))
                  masterAgentService.saveFormOpportunity(formData)
                    .then(() => {
                      Swal.fire({
                        title: 'Sucesso!',
                        text: 'Oportunidade enviada!',
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        timerProgressBar: true,
                        allowOutsideClick: false,
                      }).then(result => {
                        if (result.isDismissed) history.goBack()
                      })
                    })
                    .catch(e => {
                      swal.error(e)
                    })
                    .finally(() => {
                      setIsLoading(false)
                    })
                }
              }}
            >
              {isLoading ? (<>
                Enviando <Spinner animation="border" size="sm" />
              </>) : "Enviar"}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </>)
}

export default CyberpassForm;